var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtKalSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1h4v2H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7h2V4.5C20 2.6 18.4 1 16.5 1H16V0h-2v3h2.5c.8 0 1.5.7 1.5 1.5V5H2v-.5C2 3.7 2.7 3 3.5 3H6V0H4v1h-.5C1.6 1 0 2.6 0 4.5V7h18zM7.7 11l-1.4 1.4 3 3 4-4.7-1.5-1.4-2.6 3.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 9v8.9H2.1V9H-.1v11.1h20.2V9z"
  })));
}
export default SvgFtKalSmall;